<template>
	<div>
		<div
			class="modal fade"
			id="AgentSignUpModal"
			tabindex="-1"
			role="dialog"
			aria-labelledby="exampleModalLabel"
			aria-hidden="true"
		>
			<div class="modal-dialog" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<h5 class="modal-title" id="exampleModalLabel"
										data-test="newAgentSignUpModalHeading">Agent Registration</h5>
						<button type="button" class="close" data-dismiss="modal" aria-label="Close"
														data-test="newAgentSignUpModalCloseBtn1"
														id="newAgentSignUpModalCloseBtn1">
							<span aria-hidden="true"
													data-test="newAgentSignUpModalCloseSpan"
													id="newAgentSignUpModalCloseSpan">&times;</span>
						</button>
					</div>
					<div class="modal-body">
						<!-- Modal Body -->
						<div class="row m-0">
							<div class="col-12">
								<form data-vv-scope="register">

									<!--FirstName-->
									<div class="form-group "
														v-if="(fieldsToEnable.enableAll || fieldsToEnable.firstname)">
										<label class="control-label requiredField" for="agentfirstname"
																	data-test="newAgentSignUpModalFNLabel"
																	id="newAgentSignUpModalFNLabel">
											First Name
											<span class="asteriskField"
																	data-test="newAgentSignUpModalFNSpan"
																	id="newAgentSignUpModalFNSpan">
                        *
                      </span>
										</label>
										<input
											class="form-control"
											id="agentfirstname"
											name="firstname"
											type="text"
											placeholder="First Name"
											v-model="account.firstname"
											v-validate="'required|min:3|alpha'"
											:class="(showSignUpError &&
                    errors.has('register.firstname'))?'is-invalid':''"
											:disabled="show"
											data-test="newAgentSignUpModalFNInput"
										>
										<div class="invalid-feedback"
															v-if="showSignUpError"
															v-show="errors.has('register.firstname')"
															id="agent-signup-firstname-error"
															data-test="newAgentSignUpModalFNInputError"
										>
											{{errors.first('register.firstname')}}
										</div>
									</div>

									<!--LastName-->
									<div class="form-group "
														v-if="(fieldsToEnable.enableAll || fieldsToEnable.lastname)">
										<label class="control-label requiredField" for="agentlastname"
																	data-test="newAgentSignUpModalLNLabel"
																	id="newAgentSignUpModalLNLabel">
											Last Name
											<span class="asteriskField"
																	data-test="newAgentSignUpModalLNSpan"
																	id="newAgentSignUpModalLNSpan">
                        *
                      </span>
										</label>
										<input
											class="form-control"
											id="agentlastname"
											name="lastname"
											type="text"
											placeholder="Last Name"
											v-model="account.lastname"
											v-validate="'required|min:3|alpha'"
											:class="(showSignUpError &&
                    errors.has('register.lastname'))?'is-invalid':''"
											:disabled="show"
											data-test="newAgentSignUpModalLNInput"
										>
										<div class="invalid-feedback"
															v-if="showSignUpError"
															v-show="errors.has('register.lastname')"
															id="agent-signup-lastname-error"
															data-test="newAgentSignUpModalLNInputError"
										>
											{{errors.first('register.lastname')}}
										</div>
									</div>

									<!--Email-->
									<div class="form-group"
														v-if="(fieldsToEnable.enableAll || fieldsToEnable.email)">
										<label class="control-label requiredField" for="email"
																	data-test="newAgentSignUpModalEmailLabel"
																	id="newAgentSignUpModalEmailLabel">
											Email
											<span class="asteriskField"
																	data-test="newAgentSignUpModalEmailSpan"
																	id="newAgentSignUpModalEmailSpan">
                        *
                      </span>
										</label>
										<input
											class="form-control"
											v-model="account.email"
											id="email"
											name="agentEmail"
											type="text"
											disabled
											data-test="newAgentSignUpModalEmailInput"/>
									</div>

									<!--UserName-->
									<div class="form-group "
														v-if="(fieldsToEnable.enableAll || fieldsToEnable.username)">
										<label class="control-label requiredField" for="agentusername"
																	data-test="newAgentSignUpModalUNLabel"
																	id="newAgentSignUpModalUNLabel">
											User Name
											<span class="asteriskField"
																	data-test="newAgentSignUpModalUNSpan"
																	id="newAgentSignUpModalUNSpan">
                        *
                      </span>
										</label>
										<input
											class="form-control"
											id="agentusername"
											name="username"
											type="text"
											placeholder="UserName"
											v-model="account.username"
											v-validate="'required|min:3|alpha'"
											:class="(showSignUpError &&
                    errors.has('register.username'))?'is-invalid':''"
											:disabled="show"
											data-test="newAgentSignUpModalUNInput"
										>
										<div class="invalid-feedback"
															v-if="showSignUpError"
															v-show="errors.has('register.username')"
															id="agent-signup-username-error"
															data-test="newAgentSignUpModalUNInputError"
										>
											{{errors.first('register.username')}}
										</div>
									</div>

									<!--Password-->
									<div class="form-group" v-if="passwrd"
														v-show="(fieldsToEnable.enableAll || fieldsToEnable.password)"
									>
										<label class="control-label requiredField" for="agentpsswrd"
																	data-test="newAgentSignUpModalPsswrdLabel"
																	id="newAgentSignUpModalPsswrdLabel">
											Password
											<span class="asteriskField"
																	data-test="newAgentSignUpModalPsswrdSpan"
																	id="newAgentSignUpModalPsswrdSpan">
                        *
                      </span>
										</label>
										<input
											class="form-control"
											id="agentpsswrd"
											name="password"
											type="password"
											placeholder="Password"
											v-model="account.password"
											v-validate="'required|min:6'"
											:class="(showSignUpError &&
                    errors.has('register.password'))?'is-invalid':''"
											:disabled="show"
											data-test="newAgentSignUpModalPsswrdInput"
										/>
										<div class="invalid-feedback"
															v-if="showSignUpError"
															v-show="errors.has('register.password')"
															id="agent-signup-password-error"
															data-test="newAgentSignUpModalPsswrdInputError"
										>
											{{errors.first('register.password')}}
										</div>
									</div>

									<!--PhoneNumber-->
									<div class="form-group"
														v-if="(fieldsToEnable.enableAll || fieldsToEnable.phone_number)">
										<label class="control-label requiredField" for="number"
																	data-test="newAgentSignUpModalPhnLabel"
																	id="newAgentSignUpModalPhnLabel">
											Phone Number
											<span class="asteriskField"
																	data-test="newAgentSignUpModalPhnSpan"
																	id="newAgentSignUpModalPhnSpan">
                        *
                      </span>
										</label>
										<input
											class="form-control"
											id="number"
											name="number"
											type="text"
											placeholder="Phonenumber"
											v-model="account.phone_number"
											v-validate="'required|min:13|max:13|regex:^\\+[0-9]+$'"
											:class="(showSignUpError &&
                    errors.has('register.number')) || phnError ?'is-invalid':''"
											@blur="phoneCheck(account.phone_number)"
											:disabled="show"
											data-test="newAgentSignUpModalPhnInput"
										/>
										<div class="invalid-feedback"
															v-if="showSignUpError"
															v-show="errors.has('register.number')"
															id="agent-RegisterForm-phone-phone-error"
															data-test="newAgentSignUpModalPhnInputError1"
										>
											{{errors.first('register.number')}}
										</div>
										<div
											style="color: #dc3545"
											data-test="newAgentSignUpModalPhnInputError2"
											id="newAgentSignUpModalPhnInputError2"
											v-if="phnError"
										>
											CountryCode needed(eg. +91)
										</div>
									</div>

									<!--Adress Line 1-->
									<div class="form-group"
														v-if="(fieldsToEnable.enableAll || fieldsToEnable.address_line1)">
										<label class="control-label requiredField" for="address1"
																	data-test="newAgentSignUpModalAddrss1Label"
																	id="newAgentSignUpModalAddrss1Label">
											Address Line 1
											<span class="asteriskField"
																	data-test="newAgentSignUpModalAddrss1Span"
																	id="newAgentSignUpModalAddrss1Span">
                        *
                    </span>
										</label>
										<input
											class="form-control"
											id="address1"
											name="address"
											type="text"
											placeholder="1234 Main St"
											v-validate="'required|min:3|max:20'"
											v-model="account.address_line1"
											:class="(showSignUpError &&
                    errors.has('register.address'))?'is-invalid':''"
											:disabled="show"
											data-test="newAgentSignUpModalAddrss1Input"
										/>
										<div class="invalid-feedback"
															v-if="(showSignUpError && errors.has('register.address'))"
															id="dlvry-adrs-line1-error"
															data-test="newAgentSignUpModalAddrss1InputError"
										>
											{{errors.first('register.address')}}
										</div>
									</div>

									<!--Adress Line 2-->
									<div class="form-group "
														v-if="(fieldsToEnable.enableAll || fieldsToEnable.address_line2)">
										<label class="control-label requiredField" for="address2"
																	data-test="newAgentSignUpModalAddrss2Label"
																	id="newAgentSignUpModalAddrss2Label">
											Address Line 2
											<span class="asteriskField"
																	data-test="newAgentSignUpModalAddrss2Span"
																	id="newAgentSignUpModalAddrss2Span">
                        *
                      </span>
										</label>
										<input
											class="form-control"
											id="address2"
											name="address2"
											type="text"
											placeholder="Apartment or suite"
											v-validate="'required|min:3|max:20'"
											v-model="account.address_line2"
											:class="(showSignUpError &&
                    errors.has('register.address2'))?'is-invalid':''"
											:disabled="show"
											data-test="newAgentSignUpModalAddrss2Input"
										/>
										<div class="invalid-feedback"
															v-if="(showSignUpError && errors.has('register.address2'))"
															id="dlvry-adrs-line2-error"
															data-test="newAgentSignUpModalAddrss2InputError"
										>
											{{errors.first('register.address2')}}
										</div>
									</div>

									<!--Proof of Identity-->
									<div class="form-group "
														v-if="(fieldsToEnable.enableAll || fieldsToEnable.identity_proof) && !show"
									>
										<label class="control-label requiredField"
																	for="document-type-select"
																	data-test="newAgentSignUpModalIdentityLabel"
																	id="newAgentSignUpModalIdentityLabel">
											Proof of Identity
											<span class="asteriskField"
																	data-test="newAgentSignUpModalIdentitySpan"
																	id="newAgentSignUpModalIdentitySpan">
                        *
                      </span>
										</label>
										<select class="select form-control"
																		id="document-type-select"
																		data-test="newAgentSignUpModalIdentityInput"
																		name="documentTypeSelect"
																		style="text-transform: capitalize;"
																		v-model="account.identity_proof"
																		v-validate="'required'"
																		:class="((showSignUpError && account.identity_proof === 'Select...') || errors.has('register.documentTypeSelect'))?'is-invalid':''"
										>
											<option disabled
																			data-test="newAgentSignUpModalIdentityOption1"
																			id="newAgentSignUpModalIdentityOption1">
												Select...
											</option>
											<option v-for="(document, index) in getSelectedCountry.document_types"
																			:key="index"
																			:id="'document-upload-'+index"
																			:data-test="'newAgentSignUpModalIdentityOption2'+index"
											>
												{{document}}
											</option>
										</select>
										<div class="invalid-feedback"
															v-if="((showSignUpError && account.identity_proof === 'Select...') || errors.has('register.documentTypeSelect'))"
															id="newAgentSignUpModalIdentityError"
															data-test="newAgentSignUpModalIdentityError"
										>
											The identity proof field required
										</div>
									</div>

									<!--View Proof of Identity-->
									<div class="form-group"
														v-if="(fieldsToEnable.enableAll || fieldsToEnable.identity_proof) && show">
										<label class="control-label requiredField" for="viewproof"
																	data-test="newAgentSignUpModalViewIdentityLabel"
																	id="newAgentSignUpModalViewIdentityLabel">
											Proof of Identity
											<span class="asteriskField"
																	data-test="newAgentSignUpModalViewIdentitySpan"
																	id="newAgentSignUpModalViewIdentitySpan">
                        *
                      </span>
										</label>
										<input
											class="form-control"
											id="viewproof"
											name="viewproof"
											type="text"
											v-model="account.identity_proof"
											:disabled="show"
											data-test="newAgentSignUpModalViewIdentityInput"
										/>
									</div>

									<!--Upload-->
									<div class="form-group "
														v-if="(fieldsToEnable.enableAll || fieldsToEnable.documents) && !show">
										<label class="control-label requiredField"
																	data-test="newAgentSignUpModalUploadLabel"
																	id="newAgentSignUpModalUploadLabel">
											Upload
											<span class="asteriskField"
																	data-test="newAgentSignUpModalUploadSpan1"
																	id="newAgentSignUpModalUploadSpan1">
                        *
                      </span>
										</label>
										<div class="input-group mb-3">
											<div class="input-group-prepend">
                      <span
																							class="input-group-text"
																							id="inputGroupFileAddon01"
																							data-test="newAgentSignUpModalUploadSpan2">
                        Upload
                      </span>
											</div>
											<div class="custom-file">
												<input
													type="file"
													name="fileupload"
													class="custom-file-input"
													id="inputGroupFile01"
													accept="image/*"
													v-validate="'required|ext:jpg,png,pdf'"
													:class="(showSignUpError &&
                        errors.has('register.fileupload'))?'is-invalid':''"
													@change="uploadImages"
													aria-describedby="inputGroupFileAddon01"
													data-test="newAgentSignUpModalUploadInput"
												>
												<label class="custom-file-label"
																			for="inputGroupFile01"
																			data-test="newAgentSignUpModalUploadFNLabel"
																			id="newAgentSignUpModalUploadFNLabel">
													{{this.fileName? this.fileName : 'Choose file'}}
												</label>
											</div>
										</div>
										<div class="invalid-feedback"
															v-if="showSignUpError"
															v-show="errors.has('register.fileupload')"
															id="agent-RegisterForm-fileUpload-error"
															style="display: block"
															data-test="newAgentSignUpModalUploadError"
										>
											{{errors.first('register.fileupload')}}
										</div>
									</div>

									<div class="modal-footer" v-if="!show">
										<button
											type="button"
											class="btn btn-primary"
											@click.prevent="action('register')"
											data-test="newAgentSignUpModalBtn"
											id="newAgentSignUpModalBtn"
										>
											{{ !(editAgentDetailsForm || enableExistingUserForm) ?
											'Sign Up' :
											(enableExistingUserForm ? 'Update & Login' : 'Update Details')}}
										</button>
									</div>

									<div class="modal-footer" v-else>
										<button
											type="button"
											class="btn btn-primary"
											@click="modalClose"
											data-test="newAgentSignUpModalCloseBtn2"
											id="newAgentSignUpModalCloseBtn2"
										>
											Close
										</button>
									</div>

								</form>
							</div>
						</div>
						<!-- Modal Body -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
// import vendorLoginModal from '@/components/pages/vendor/vendorLoginModal';
// import { vendorApis } from '@/services/ApiServices/vendorApis'
import { vendorCommon } from '../../../../commonJs/vendorAndAgent'
import { mapGetters } from 'vuex'

export default {
	name: 'agent-sign-up-modal',
	components: {
		// vendorLoginModal,
	},
	props: {
		agentAccount: {},
		show: {
			type: Boolean,
			default: false
		},
		passwrd: {
			type: Boolean,
			default: true
		},
		enableExistingUserForm: {
			default: false,
			type: Boolean
		},
		editAgentDetailsForm: {
			default: false,
			type: Boolean
		}
	},
	data () {
		return {
			showSignUpError: false,
			account: {
				documents: '',
				identity_proof: 'Select...'
			},
			phnError: false,
			imageUploadUrl: {},
			fileName: '',
			/* Fields Required for Existing customer */
			existingUserFieldList: {
				username: true,
				address_line1: true,
				address_line2: true,
				identity_proof: true,
				documents: true,
				email: true,
				password: true
			},
			/* Form list for New agent Sign Up */
			newUserFieldList: {
				enableAll: true
			},
			/* Form list for edit agent details */
			editAgentFieldList: {
				firstname: true,
				lastname: true,
				password: false,
				address_line1: true,
				address_line2: true,
				identity_proof: true,
				email: true,
				phone_number: true,
				documents: true
			}
		}
	},
	mounted () {
		this.account = this.agentAccount
		if (!this.account.identity_proof) {
			this.account.identity_proof = 'Select...'
		}
	},
	methods: {
		action (scope) {
			this.$validator.validateAll(scope)
				.then((result) => {
					if (result && this.account.identity_proof !== 'Select...') {
						this.showSignUpError = false
						if (this.enableExistingUserForm) {
							/* Update agent data and login */
							this.$emit('agentUpdateAndLogin', this.account)
						} else if (this.editAgentDetailsForm) {
							// Update Existing Agent Data
							this.$emit('agentDetailsUpdate', this.account)
						} else {
							/* sing Up new agent */
							this.$emit('agentsignUp', this.account)
						}
						$('#AgentSignUpModal').modal('hide')
					} else {
						this.showSignUpError = true
					}
				})
		},
		phoneCheck (phoneNumber) {
			const ph = phoneNumber.split('+')
			this.phnError = ph.length === 1
		},
		async uploadImages (event) {
			this.account.documents = await vendorCommon.imageUploader(event)
			if (this.account.documents !== '') {
				this.fileName = event.target.files[0].name
			}
		},
		selectoption (event) {
			this.account.identity_proof = event.target.value
		},
		modalClose () {
			this.$emit('agentSignUpModalClose')
		}
	},
	computed: {
		...mapGetters('siteData', ['getTenantConfig', 'getSelectedCountry']),
		fieldsToEnable () {
			if (this.enableExistingUserForm) {
				return this.existingUserFieldList
			} else if (this.editAgentDetailsForm) {
				return this.editAgentFieldList
			}
			return this.newUserFieldList
		}
	},
	watch: {
		agentAccount () {
			this.account = this.agentAccount
			if (!this.account.identity_proof) {
				this.account.identity_proof = 'Select...'
			}
			if (!this.account.documents) {
				this.account.documents = ''
			}
		}
	}
}
</script>
